import { GridAction } from '@eforall/dashboard';
import { StaffData } from '@interfaces';

export function getActions() {

	const actions: GridAction<StaffData & { updatedUTC: number }>[] = [
	];

	return actions;
}